var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schedule-container"},[_vm._v("\n\n    "+_vm._s(_vm.screenWidth)+"\n    "),_c('br'),_vm._v("\n    "+_vm._s(_vm.screenHeight)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }